import {
  Accordion,
  AccordionButton,
  AccordionIcon,
  AccordionItem,
  AccordionPanel,
  Box,
  Flex,
  Heading,
} from '@chakra-ui/react';
import { Icon } from '@common/components/Icon';
import { FontFamily } from '@common/theming/Fonts';
import React from 'react';
import { Link as RRDLink } from 'react-router-dom';
import { ROUTES } from 'src/apps/invest/config';

import { useDocumentsViewModel } from '../../models/DocumentsViewModel';

export const Statements: React.FC = () => {
  const documentsViewModel = useDocumentsViewModel();
  const links = documentsViewModel.getStatementMonths(new Date('2021-06-03'));
  return (
    <Box w="100%" p="24px">
      <Heading lineHeight={1} fontWeight="normal" fontFamily={FontFamily.HELVETICA_NOW_BOLD} mb="24px">
        Statements
      </Heading>
      <Box w="full">
        <Accordion w={'full'} allowToggle={true} allowMultiple={true}>
          {Object.keys(links)
            .sort()
            .reverse()
            .map((year) => {
              return (
                <AccordionItem w="full" key={`year-${year}`}>
                  <AccordionButton>
                    <Box fontWeight={'bold'} textAlign={'left'} flex={1}>
                      {year}
                    </Box>
                    <AccordionIcon />
                  </AccordionButton>
                  <AccordionPanel borderTopWidth={1} borderTopStyle="solid" px="0px">
                    {links[year].map((link) => {
                      return (
                        <Flex
                          target={'_blank'}
                          _hover={{ backgroundColor: 'blue.50' }}
                          py="8px"
                          px="16px"
                          as={RRDLink}
                          to={ROUTES.statement(link.month)}
                          alignItems={'center'}
                          justifyContent="space-between"
                          key={`month-${link.month}`}>
                          <Flex alignItems={'center'} color="blue.500">
                            {link.label}
                          </Flex>
                          <Icon variant="regular" icon="file-arrow-down"></Icon>
                        </Flex>
                      );
                    })}
                  </AccordionPanel>
                </AccordionItem>
              );
            })}
        </Accordion>
      </Box>
    </Box>
  );
};
